import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addItemToFavouriteList,
  fetchFavouriteProducts,
  removeItemFromFavourite,
} from "./actions";

interface FavouriteProductList {
  isLoading: boolean;
  isError: boolean;
  listName: string;
  listId: string;
  favouriteProducts: {
    products: Product[];
    custom: CustomItem[];
  };
  message: string;
  errorMessage: string;
}

interface Product {
  item_id: any;
  id: number;
  name: string;
  quantity: number;
}

interface CustomItem {
  id: string;
  description: string;
}

interface UserData {
  userId: string;
  categoryId: string;
}

const initialState: FavouriteProductList = {
  isLoading: false,
  isError: false,
  listName: "",
  message: "",
  errorMessage: "",
  favouriteProducts: {
    products: [],
    custom: [],
  },
  listId: "",
};
const fallbackErrorMessage = ""


export const favouriteProductSlice = createSlice({
  name: "favouriteProductSlice",
  initialState,
  reducers: {
    resetFavouriteProductList: () => initialState,
    setFavouriteMessage: (
      state,
      action: PayloadAction<{ message?: string; errorMessage?: string } | undefined>
    ) => {
      if (!action.payload) {
        state.message = "";
        state.errorMessage = "";
      } else {
        if (action.payload.message !== undefined) {
          state.message = action.payload.message;
        }
        if (action.payload.errorMessage !== undefined) {
          state.isError = true;
          state.errorMessage = action.payload.errorMessage;
        }
      }
    },
  },
  extraReducers: (builder) => {
   
    // add to favourite
    builder.addCase(addItemToFavouriteList.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
      state.message = "";
    });
    builder.addCase(addItemToFavouriteList.fulfilled,(state: any, 
      action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        const itemData = action.payload?.itemData;
          if (itemData) {
            const existingIndex = state.favouriteProducts.products.findIndex(
              (item: { item_id: string }) => item?.item_id == itemData.item_id
            );   
            if (existingIndex !== -1) {
                state.favouriteProducts.products[existingIndex] = itemData;
            } 
            else {
                state.favouriteProducts.products.push(itemData);
            }
          }
        state.message = "Product added to favourites"

      }
    );
    builder.addCase(addItemToFavouriteList.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
      state.message = "";


    });

    builder.addCase(removeItemFromFavourite.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
      state.message = "";
    });

    builder.addCase(
      removeItemFromFavourite.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.favouriteProducts.products = state.favouriteProducts.products.filter(
          (item: Product) => item?.item_id !==  action.payload.itemData.item_id
        );
        state.message = "Product removed from favourites"
      }
    );
    builder.addCase(removeItemFromFavourite.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
      state.message = "";
    });

    // Get list items
    builder.addCase(fetchFavouriteProducts.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
      state.message = "";

    });
    builder.addCase(fetchFavouriteProducts.fulfilled, (state: any, action) => {
      // debugger
      state.isLoading = false;
      state.isError = false;
      state.message = "";
      if (action.payload?.data) {
        state.favouriteProducts.products = action.payload.data.map((item: { item_id: string; banner: string; }) => ({
          item_id: item.item_id,
          banner: item.banner
        }));
      } 
    });
    builder.addCase(fetchFavouriteProducts.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
      state.message = "";

    });

  },
});

export const {
  resetFavouriteProductList,
  setFavouriteMessage,
} = favouriteProductSlice.actions;
export const favouriteProductSliceReducer = favouriteProductSlice.reducer;